export const selectCurrentProperty = state => state.property.currentProperty

export const selectCurrentPropertyId = state => state.property?.currentProperty?.id

export const selectUnitOfMeasurement = state => state.property?.currentProperty?.measurement
